import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeliveryOutputDto } from 'src/generated_client';

export interface CadetSearchDialogData {
  title: string;
  message: string;
  cadets: DeliveryOutputDto[];
  confirmButtonText: string;
  cancelButtonText: string;
}

@Component({
  selector: 'app-cadet-search-dialog',
  templateUrl: './cadet-search-dialog.component.html',
  styleUrls: ['./cadet-search-dialog.component.css']
})
export class CadetSearchDialogComponent implements OnInit {
  searchControl = new FormControl('');
  filteredCadets: DeliveryOutputDto[] = [];
  selectedCadet: DeliveryOutputDto | null = null;

  constructor(
    public dialogRef: MatDialogRef<CadetSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CadetSearchDialogData,
    private fb: FormBuilder
  ) {
    this.filteredCadets = [...data.cadets];
  }

  ngOnInit(): void {
    this.searchControl.valueChanges.subscribe(searchTerm => {
      if (!searchTerm) {
        this.filteredCadets = [...this.data.cadets];
        return;
      }
      
      const searchLower = searchTerm.toLowerCase();
      this.filteredCadets = this.data.cadets.filter(cadet => 
        (cadet.dsName?.toLowerCase().includes(searchLower) ||
         cadet.dsPhone?.includes(searchTerm))
      );
    });
  }

  selectCadet(cadet: DeliveryOutputDto): void {
    this.selectedCadet = cadet;
  }

  onConfirm(): void {
    if (this.selectedCadet) {
      this.dialogRef.close({
        confirmed: true,
        selectedValue: this.selectedCadet.cdDelivery?.toString()
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }
}
